import { z } from '@hono/zod-openapi'
import { benefitsTable, type CalendarExceptionDay } from '@mattrika/benefit-db'
import { createInsertSchema, createSelectSchema } from 'drizzle-orm/zod'
import { zCommonQuery } from '../common/common.model'

export const zCalendarExceptionDay: z.ZodType<CalendarExceptionDay> = z.object({
    date: z.string(),
    status: z.enum(['available', 'not-redeemable', 'peak-season']),
})

export const zSelectBenefit = createSelectSchema(benefitsTable, {
    calendarExceptions: z.array(zCalendarExceptionDay).nullable(),
})

export const zInsertBenefit = createInsertSchema(benefitsTable, {
    calendarExceptions: z.array(zCalendarExceptionDay).optional().nullable(),
}).omit({
    id: true,
    createdAt: true,
    updatedAt: true,
})

export const zUpdateBenefit = zInsertBenefit.partial()

export const zQueryBenefits = zInsertBenefit
    .extend({
        id: z.string(),
        ids: z.string().array(),
        status: z.enum(['draft', 'published', 'expired', 'rejected']),
    })
    .extend(zCommonQuery.shape)
    .partial()

export type SelectBenefit = z.infer<typeof zSelectBenefit>
export type InsertBenefit = z.infer<typeof zInsertBenefit>
export type UpdateBenefit = z.infer<typeof zUpdateBenefit>
export type QueryBenefits = z.infer<typeof zQueryBenefits>
export type ColumnsOfBenefitsTable = keyof typeof benefitsTable._.columns
